"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var BASE_URL = '/properties/v1/contacts';
var _default = {
  fetchProperties: function fetchProperties() {
    return _apiClient.default.get(BASE_URL + "/groups", {
      query: {
        includeProperties: true
      }
    });
  },
  createProperty: function createProperty(field) {
    return _apiClient.default.post(BASE_URL + "/properties", {
      data: field
    });
  }
};
exports.default = _default;
module.exports = exports.default;